import * as React from "react";

const ParticipantPinIcon = (props) => (
  <svg
    width={18}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="a"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={18}
      height={18}
    >
      <path fill="#D9D9D9" d="M0 0h18v18H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        d="M12.072.5H5.42c-.154 0-.306.028-.448.084a1.177 1.177 0 0 0-.38.238 1.098 1.098 0 0 0-.254.358 1.045 1.045 0 0 0-.089.422c-.001.145.028.289.086.423.058.134.144.256.253.36.11.102.239.183.382.238.143.054.296.082.45.08h.215v5.478L4.064 9.95a.3.3 0 0 0-.031.32.344.344 0 0 0 .116.118c.048.03.103.049.161.055h8.838a.294.294 0 0 0 .216-.088c.03-.029.03-.058.061-.087a.297.297 0 0 0-.03-.32L11.86 8.21V2.732h.216a1.22 1.22 0 0 0 .45-.08c.142-.055.272-.136.381-.239.11-.102.195-.225.254-.359a1.093 1.093 0 0 0-.256-1.216A1.233 1.233 0 0 0 12.072.5ZM8.438 16.268a.354.354 0 0 0 .12.157c.054.041.12.067.188.075a.294.294 0 0 0 .216-.087.627.627 0 0 0 .092-.145l1.448-5.245h-3.48l1.416 5.245Z"
        fill={props.fill}
      />
    </g>
  </svg>
);

export default ParticipantPinIcon;
